import { Button } from '@servicetitan/design-system';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  margin-top: 0px;
  margin-bottom: -2px;
  padding: 2px !important;
  & svg {
    width: 16px !important;
    height: 16px !important;
  }
`;
